import { cn } from '@/lib/utils';

export default function LocationBadge({
  location,
  area,
  shouldShowHoverEffects,
}: {
  location: string;
  area: string;
  shouldShowHoverEffects?: boolean;
}) {
  return (
    <div
      className={cn(
        'flex items-center gap-1.5 font-extrabold text-lg uppercase transition-all duration-300 ease-out font-milligram w-full overflow-hidden',
        shouldShowHoverEffects ? 'text-brand-blue text-shadow-xs' : 'text-primary'
      )}
    >
      <span className="text-nowrap">{location}</span>
      <span className="flex-shrink-0">•</span>
      <span className="truncate">{area}</span>
    </div>
  );
}
